import { MutationTree } from 'vuex';
import { PartyState } from './types';

export const mutations: MutationTree<PartyState> = {
    setData(state, payload: any) {
        state.data.party = payload.data;
        state.loading = false;
    },
    setError(state, error: any) {
        state.error = true;
        state.data.party = undefined;
        state.loading = false;
    },
    setLoading(state) {
        state.loading = true;
    },
    setCommentsData(state, payload: any) {
        state.data.comments = payload;
        state.commentsLoading = false;
    },
    setCommentsError(state, error: any) {
        state.commentsError = true;
        state.data.comments = undefined;
        state.commentsLoading = false;
    },
    setCommentsLoading(state) {
        state.commentsLoading = true;
    },
    setAttachmentsData(state, payload: any) {
        state.data.attachments = payload.data;
        state.attachmentsLoading = false;
    },
    setAttachmentsError(state, error: any) {
        state.attachmentsError = true;
        state.data.attachments = undefined;
        state.attachmentsLoading = false;
    },
    setAttachmentsLoading(state) {
        state.attachmentsLoading = true;
    },
    setContactsData(state, payload: any) {
        state.data.contacts = payload;
        state.contactsLoading = false;
    },
    setContactsError(state, error: any) {
        state.contactsError = true;
        state.data.contacts = undefined;
        state.contactsLoading = false;
    },
    setContactsLoading(state) {
        state.contactsLoading = true;
    },
};
